class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      open: "mini-cart--open",
      opening: "mini-cart--opening",
      closing: "mini-cart--closing",
    };

    this.drawer = document.querySelector("cart-drawer");
    this.detailsElement = this.drawer.querySelector("details");

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    this.drawer.addEventListener("click", this.openDrawer.bind(this));

    this.footerObserver = null;
    this.cartStateObserver = null;
    this.onBodyClickEvent = null;

    this.observeCartOpenState();
  }

  observeCartOpenState() {
    this.cartStateObserver = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === "class") {
          const isOpen = this.classList.contains("open-cart-drawer");
          if (isOpen) {
            this.updateFooterHeight();
            this.observeFooterHeight();
          }
        }
      }
    }.bind(this));

    this.cartStateObserver.observe(this, { attributes: true });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("mini-cart").innerHTML =
          this.getSectionInnerHTML(html, ".shopify-section");
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector("details");
    if (detailsElement.hasAttribute("open")) return;

    const summaryElement = this.drawer.querySelector("summary");
    summaryElement.click();
  }

  openDrawer() {
    if (document.body.classList.contains('smart-cart--enabled')) {
      document.body.classList.add("rebuy-cart-visible");
    } else {
      const wasAlreadyOpen = this.classList.contains("open-cart-drawer");
      this.classList.add("open-cart-drawer");
      document.body.classList.add("mini-cart--open");

      if (!wasAlreadyOpen && typeof GTMDataLayer !== 'undefined') {
        GTMDataLayer.fetchAndTrackCart();
      }

      setTimeout(() => {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        document.body.addEventListener("click", this.onBodyClickEvent);

        const cartItems = this.querySelector("cart-items");
        cartItems?.fixFormHeight();

        this.updateFooterHeight();
        this.observeFooterHeight();
      });
    }
  }

  closeDrawer(event) {
    if (event !== undefined) {
      this.classList.remove("open-cart-drawer");
      document.body.classList.remove("mini-cart--open");
      document.body.removeEventListener("click", this.onBodyClickEvent);
      this.detailsElement.removeAttribute("open");

      const formMiniCart = document.querySelector("form.mini-cart");
      formMiniCart?.classList.remove("min-height");
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.closeDrawer(event);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    if (this.header) this.header.reveal();
    if (!document.body.classList.contains('smart-cart--enabled')) {
      if (!this.classList.contains("open-cart-drawer")) this.open();
    }

    const cartCountBubbles = document.querySelectorAll(".js-cart-count-bubble");
    const totalItems = document.querySelectorAll(".js-mini-cart-item");
    // Calculate total once, outside the loop
    let totalItemsCount = 0;
    if (totalItems.length > 0) {
      totalItems.forEach((item) => {
        const quantityInput = item.querySelector('[name="updates[]"]');
        if (quantityInput) {
          const itemQuantity = parseInt(quantityInput.value);
          if (!isNaN(itemQuantity)) {
            totalItemsCount += itemQuantity;
          }
        }
      });
    }
    // Apply the calculated total to all bubbles
    for (const bubble of cartCountBubbles) {
      const bubbleAmount = bubble.querySelector(".js-cart-count-bubble-amount");

      if (!bubbleAmount) continue; // Skip if element not found

      if (totalItemsCount > 0) {
        bubble.classList.remove("visually-hidden");
        bubbleAmount.innerText = totalItemsCount;
      } else {
        bubble.classList.add("visually-hidden");
        bubbleAmount.innerText = 0;
      }
    }
    this.updateFooterHeight();
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  updateFooterHeight() {
    const footer = this.querySelector(".js-mini-cart-footer");
    if (footer) {
      requestAnimationFrame(() => {
        const height = footer.offsetHeight;
        document.documentElement.style.setProperty("--mini-cart-footer-height", `${height}px`);
      });
    }
  }

  observeFooterHeight() {
    const footer = this.querySelector(".js-mini-cart-footer");
    if (!footer) return;

    if (!this.footerObserver) {
      this.footerObserver = new ResizeObserver(() => {
        this.updateFooterHeight();
      });
    }

    this.footerObserver.observe(footer);
  }

  disconnectedCallback() {
    if (this.cartStateObserver) {
      this.cartStateObserver.disconnect();
      this.cartStateObserver = null;
    }

    if (this.footerObserver) {
      this.footerObserver.disconnect();
      this.footerObserver = null;
    }

    if (this.onBodyClickEvent) {
      document.body.removeEventListener("click", this.onBodyClickEvent);
      this.onBodyClickEvent = null;
    }
  }
}

customElements.define("mini-cart", MiniCart);

class CartDrawerCloseButton extends HTMLElement {
  constructor() {
    super();

    var miniCart = document.querySelector("mini-cart");
    const header = document.querySelector('header')
    const body = document.querySelector('body');
    this.addEventListener("click", (event) => {
      event.preventDefault();
      miniCart.closeDrawer(event);
      header?.classList.toggle('mini-cart-open');
      body?.classList.toggle('overflow-hidden');
    });
  }
}

customElements.define("cart-drawer-close-button", CartDrawerCloseButton);
